var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Carrito',{attrs:{"button_color":"white","carritoItems":_vm.carritoItems,"secondsLeft":_vm.carrito?.seconds_left},on:{"eliminarProducto":_vm.eliminarProducto,"irADetalleCarrito":_vm.irADetalleCarrito}})
}
var staticRenderFns = []

export { render, staticRenderFns }